import {
    FilterModuleConfig,
    transformToGenericFilterConfig,
} from '@core/modules/filters'
import { UnifiedFilterConfig, SearchKeyConfig } from '@core/modules/filters/unified-filter.module'
import { EIssueSeverity } from '@core/modules/issues/constants'

export type TAssetsFilterType = 'asset_type'

export const assetsSearchKeys: SearchKeyConfig[] = [
    { value: 'hostname', threshold: 0.3 },
    { value: 'asset_type', threshold: 0.2 },
    { value: 'last_seen', threshold: 0.4 },
    { value: 'issues.severity', threshold: 0.2 },
    { value: 'issues.name', threshold: 0.3 },
]

const config = {
    asset_type: {
        accessor: 'asset_type',
        label: 'Asset type',
        collapsible: true,
        filters: {},
    },
}

const defaultFilters = {
    asset_type: {},
}

export const assetsFilterConfig: FilterModuleConfig =
    transformToGenericFilterConfig(
        { assets: config },
        { assets: defaultFilters }
    ).assets

export const unifiedAssetsConfig: UnifiedFilterConfig = {
    ...assetsFilterConfig,
    searchKeys: assetsSearchKeys,
    sortStrategy: (a: TAsset, b: TAsset) => {
        const getRank = (asset: TAsset) => {
            const openIssues =
                asset.issues?.filter((i) => i.status === 'open') || []
            if (openIssues.length === 0) return 0
            return openIssues.reduce((max, issue) => {
                const rank =
                    EIssueSeverity[
                        issue.severity as keyof typeof EIssueSeverity
                    ] || 0
                return Math.max(max, rank)
            }, 0)
        }

        const aRank = getRank(a)
        const bRank = getRank(b)

        if (bRank !== aRank) {
            return bRank - aRank
        }

        const aIssuesCount = a.issues?.length || 0
        const bIssuesCount = b.issues?.length || 0
        return bIssuesCount - aIssuesCount
    },
}

export { config, defaultFilters }
